module.exports = __webpack_public_path__ + "media/component-library/apple-login-button/copy/de-7adc99613cf3f6f81c563997d545d7e3.svg";